import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 45B91FE5-E3A6-44A3-B89E-5AE492BE231A
 * name image-filter-hdr-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-filter-hdr-outline.svg
 * tags
 * - Photography 
 * - Nature 
 */
export const ImageFilterHdrOutlineIcon = createSvgIcon(<><path d="M23 18H1L8.25 8.33L10.25 11L14 6L23 18M11.5 12.67L14 16L19 16L14 9.33L11.5 12.67M5 16L11.5 16L8.25 11.67L5 16Z" /></>, 'ImageFilterHdrOutlineIcon');
export default ImageFilterHdrOutlineIcon